export enum COOKIE_NAMES {
    LMI_MA = '__lmi_ma',
    MARKETO_TRK = '_mkto_trk',
    CHOP_ID = 'chop_id',
    GCL_ID = 'gclid_cookie',
    GCL_ID_2 = 'gclid',
    GTC_EMAIL = 'gtc-email',
    GEO_IP = 'visitor_geoip_country',
}
